// src/config/CustomSnackbarStyles.js

import { styled } from "@mui/material/styles";
import { MaterialDesignContent } from "notistack";

const NotificationStyle = styled(MaterialDesignContent)(() => ({
  "&.notistack-MuiContent-success": {
    backgroundColor: "rgba(222, 255, 232,0.5)", // Semi-transparent white , "#deffe8",
    borderRadius: "15px",
    borderLeft: "4px  solid #17ea80", // Optional border for more contrast
    fontSize: "1rem",
    marginRight: "60px",
    marginBottom: "5px",
    color: "rgba(0, 0, 0,1)",
    backdropFilter: "blur(10px)", // Blurry background
    boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)", // Nice
    pointerEvents: "none",
    zIndex: 1300,  },
  "&.notistack-MuiContent-info": {
    backgroundColor: "#e0f7fa", // Semi-transparent white
    borderRadius: "15px",
    borderLeft: "4px  solid #00bcd4", // Optional border for more contrast
    fontSize: "1rem",
    marginRight: "60px",
    marginBottom: "5px",
    color: "rgba(0, 0, 0,1)",
    backdropFilter: "blur(10px)", // Blurry background
    boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)", // Nice
    zIndex: 1300,
  },
  "&.notistack-MuiContent-error": {
    backgroundColor: "#ffd1d0", // Semi-transparent white
    borderRadius: "15px",
    color: "rgba(0, 0, 0,1)",
    fontSize: "1rem",
    marginRight: "60px",
    marginBottom: "5px",

    backdropFilter: "blur(10px)", // Blurry background
    boxShadow: "0 0 12px rgba(0, 0, 0, 0.1)", // Nice
    borderLeft: "4px  solid #e91a17", // Optional border for more contrast
    zIndex: 1300,
  },
}));

export { NotificationStyle };
